import { Component } from '@angular/core'

@Component({
  selector: 'cover-new-paypal',
  templateUrl: './new-paypal.component.html',
  styleUrls: ['./new-paypal.component.scss'],
})
export class NewPaypalComponent {}
